import { AppAction } from 'actions/types/ActionTypes'
import { API_CALL } from 'actions/actionConstants'
import { BUSINESS_TRAVELLER_API_ACTIONS } from 'reducers/businessTravellerApiActionReducers'
import requestGetItemPolicyBudget from 'businessTraveller/api/requestGetItemPolicyBudget'
import type { FetchItemPolicyBudgetParams } from 'businessTraveller/types/itemPolicyBudget.types'

function fetchItemPolicyBudget(params: FetchItemPolicyBudgetParams): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const current = state.businessTraveller.itemPolicyBudgets?.[params.cacheKey]

    if (!current || current.status === 'failed') {
      dispatch({
        type: API_CALL,
        api: BUSINESS_TRAVELLER_API_ACTIONS.FETCH_ITEM_POLICY_BUDGET,
        cacheKey: params.cacheKey,
        request: () => requestGetItemPolicyBudget(params),
      })
    }
  }
}

export default fetchItemPolicyBudget
